module.exports = __webpack_public_path__ + "img/logo-ryxly.f537f80e.png";